module.exports = __webpack_public_path__ + "img/wzh.1390ceba.jpg";